var Modal = require("components/utility/AltModal");
var StudentAvatar = require("components/avatars/StudentAvatar");

require("games/animation_modal.scss");

class AnimationModal extends React.Component {

    constructor(props) {
		super();
		autobind(this);
	}

    show() {
		this.refs.modal.show();
	}

    render() {
        var studentAvatar = (
        <div className = "studentAvatar"> 
            <StudentAvatar
                student={this.props.student}
                maxWidth={200}
                location={"modal"}
                previewAnimation={this.props.previewAnimation}
            />
        </div>
        )

        var title = "Preview Animation"
        return (
            <Modal ref="modal" className="animationModal" headerText={title}>
                <div className = "studentAvatar">
                    {studentAvatar}
                </div>
            </Modal>
        );
    }
}

module.exports = AnimationModal;



// WEBPACK FOOTER //
// ./modules/components/games/AnimationModal.js